var _ellipse, _path, _rect, _rect2, _rect3, _polygon, _polygon2, _rect4, _rect5, _rect6, _rect7, _path2, _circle, _rect8, _ellipse2, _path3, _rect9, _rect10, _ellipse3, _path4, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bfca6550-aec3-4c0b-b342-e4bc13b78253",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 840.5,
    height: 427.81293,
    viewBox: "0 0 840.5 427.81293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.87223,
    cy: 328.665,
    rx: 29.09932,
    ry: 59.37437,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363.30943,661.99829c-11.65458-69.92526-.11734-139.59789.00056-140.29293l2.267.384c-.11734.69168-11.58834,69.99825.00056,139.53165Z",
    transform: "translate(-179.75 -236.14703)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 358.70631,
    y: 558.94618,
    width: 29.84136,
    height: 2.29972,
    transform: "translate(-399.75211 6.28694) rotate(-28.1416)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 344.7038,
    y: 552.22913,
    width: 2.29972,
    height: 29.84239,
    transform: "translate(-497.13412 368.28467) rotate(-61.84204)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 720.05882,
    y: 3.9629,
    width: 47.69403,
    height: 165.09473,
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "799.25 138 683.25 0 450.404 2.129 309.156 139.707 312.01 141.542 310.991 141.542 310.991 427.706 798.937 427.706 798.937 141.542 799.25 138",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "683.371 0.294 538.455 170.193 538.455 427.706 798.937 427.706 798.937 137.873 683.371 0.294",
    fill: "#6c63ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 643.01459,
    y: 285.29778,
    width: 53.19723,
    height: 47.02019,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 643.01459,
    y: 203.91097,
    width: 53.19723,
    height: 46.27453,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 643.01459,
    y: 285.29778,
    width: 53.19723,
    height: 47.02019,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 643.01459,
    y: 203.91097,
    width: 53.19723,
    height: 46.27453,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M682.07942,655.46236s1.14042-23.89608,24.51916-21.11849",
    transform: "translate(-179.75 -236.14703)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 495.72365,
    cy: 384.87436,
    r: 11.70089,
    fill: "#6c63ff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 493.81974,
    y: 404.57796,
    width: 3.30288,
    height: 23.12018,
    fill: "#e6e6e6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.9552,
    cy: 237.09638,
    rx: 56.91484,
    ry: 116.12927,
    fill: "#6c63ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M297.04464,663.14809c-22.76458-136.5853-.22962-272.67317.00057-274.03181l2.267.384c-.22962,1.35528-22.69834,137.0771.00056,273.27052Z",
    transform: "translate(-179.75 -236.14703)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 286.95709,
    y: 462.86926,
    width: 58.36761,
    height: 2.29972,
    transform: "translate(-361.23295 -32.18428) rotate(-28.1416)",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 260.66997,
    y: 448.63286,
    width: 2.29972,
    height: 58.36761,
    transform: "translate(-462.75097 247.02458) rotate(-61.84258)",
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.75351,
    cy: 167.20096,
    rx: 77.88347,
    ry: 158.91374,
    fill: "#6c63ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M434.59671,663.14809c-31.1399-186.83717-.3144-372.9922.00056-374.85051l2.267.384c-.3144,1.85494-31.07366,187.64393.00056,374.08922Z",
    transform: "translate(-179.75 -236.14703)",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 420.37482,
    y: 389.57518,
    width: 79.87126,
    height: 2.29972,
    transform: "translate(-309.62058 27.14913) rotate(-28.1416)",
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 384.82647,
    y: 369.67007,
    width: 2.29972,
    height: 79.87126,
    transform: "translate(-337.04307 320.472) rotate(-61.84329)",
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    y: 425.81293,
    width: 840.5,
    height: 2,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 406.60242,
    y: 272.82126,
    width: 53.19723,
    height: 47.02019,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 406.60242,
    y: 191.43445,
    width: 53.19723,
    height: 46.27453,
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 406.60242,
    y: 272.82126,
    width: 53.19723,
    height: 47.02019,
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 406.60242,
    y: 191.43445,
    width: 53.19723,
    height: 46.27453,
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d8b8c9d8.svg";
export { ForwardRef as ReactComponent };